import { Grid } from '@mui/material';
import MUIList from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

import { makeStyles } from 'tss-react/mui';

import { useConfigContext } from '@lumirental/lumi-web-shared/lib/contexts/Config.context';
import { useLanguageContext } from '@lumirental/lumi-web-shared/lib/contexts/Language.context';
import getPublicCDNLink from '@lumirental/lumi-web-shared/lib/utils/cdnLinks/getPublicCDNLink';

import styles from './DynamicContent.style';

const useStyles = makeStyles()(styles);

const List = ({ list }) => {
  const { language } = useLanguageContext();

  return (
    <MUIList sx={{ listStyle: 'initial', marginInlineStart: '35px' }}>
      {list?.[language]?.map((item) => (
        <>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary={item} />
          </ListItem>
        </>
      ))}
    </MUIList>
  );
};

export default function DynamicContent({ content }) {
  const { classes } = useStyles();

  const { language } = useLanguageContext();
  const { appEnv } = useConfigContext();

  return (
    <Grid container justifyContent="start">
      <Typography
        variant="h2"
        className={classes.title}
        sx={{ marginBottom: 2 }}
      >
        {content.title[language]}
      </Typography>
      {content.data.map((el, i) => {
        const itemClasses = `${classes.item} ${classes[el.class]}`;
        if (el.type === 'list') {
          // eslint-disable-next-line react/no-array-index-key
          return <List key={`${i}_content`} list={el.text} />;
        }
        const formattedText = el.text[language].replace(
          /{{.+}}/,
          () =>
            `<span>
              <a 
                class="${classes.link} ${itemClasses}"
                href=${getPublicCDNLink(el?.link?.[language]?.url, appEnv)}
                download=${el?.link?.[language]?.fileName}
                target="_blank"
                rel="nofollow noopener noreferrer"
              >
                ${el?.link?.[language]?.text}
              </a>
            </span>`,
        );
        return (
          <Typography
            // eslint-disable-next-line react/no-array-index-key
            key={`${i}_content`}
            variant={el.type}
            className={itemClasses}
            dangerouslySetInnerHTML={{
              __html: formattedText,
            }}
          />
        );
      })}
    </Grid>
  );
}
